import { COMPETENCIES_ROUTES } from '../../constants/_routes'
import competenciesTypes from '../../constants/competenciesTypes'
import { axios } from '../../services'

// import { try_force_logoff } from '../auth'

const create_competency_request = () => {
  return {
    type: competenciesTypes.create.request
  }
}

const create_competency_success = (response) => {
  return {
    type: competenciesTypes.create.success,
    payload: response.data
  }
}

const create_competency_failure = (messages) => {
  return {
    type: competenciesTypes.create.failure,
    payload: messages
  }
}

const create_competency = (values) => {
  return function (dispatch) {
    // Before Request
    dispatch(create_competency_request())

    // Request
    axios.post(
      COMPETENCIES_ROUTES.create,
      values
    ).then( response => {
      // success
      dispatch( create_competency_success(response) )

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error creating competency."]
      }
      // dispatch( try_force_logoff(error.response) )
      dispatch( create_competency_failure(errors))
    })
  }

}

export {
  create_competency
}



// WEBPACK FOOTER //
// ./src/js/actions/competencies/create.js